module.exports = __webpack_public_path__ + "static/media/Employee2.929f3f63.svg";